import getTabIdFromProjection from 'owa-popout-v2/lib/utils/getTabIdFromProjection';
import getTabById from 'owa-tab-store/lib/utils/getTabById';

export default function getSxSIdFromProjection(targetWindow: Window): string | null {
    const tabId: string | null = getTabIdFromProjection(targetWindow);
    const tab = getTabById(tabId);
    return tab?.sxsId || null;
}
